function getCardIcon(str) {
  switch (getCardType(str)) {
    case "visa":
      str = "fa fa-cc-visa fa-lg";
      break;
    case "mast":
      str = "fa fa-cc-mastercard fa-lg";
      break;
    case "amex":
      str = "fa fa-cc-amex fa-lg";
      break;
    case "disc":
      str = "fa fa-cc-discover fa-lg";
      break;
    default:
      str = "fa fa-credit-card fa-lg";
  }

  return str;
}

function getCardType(str) {
  if (str.includes("Visa", 0)) {
    return "visa";
  } else if (str.includes("Mast", 0)) {
    return "mast";
  } else if (str.includes("Amex", 0)) {
    return "amex";
  } else if (str.includes("Disc", 0)) {
    return "disc";
  } else {
    return "";
  }
}

const CCard = ({ data }) => {
  return (
    <table
      className="approved assigned"
      style={{ marginTop: "20px", marginBottom: "25px" }}
    >
      <thead>
        <tr>
          <th className="right" style={{ width: "20%", paddingTop: "10px" }}>
            Credit Card:
          </th>
          <td className="left" style={{ paddingTop: "10px" }}>
            <i className={getCardIcon(data)}></i> &nbsp;{data}
          </td>
        </tr>
      </thead>
    </table>
  );
};

export default CCard;
